import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

async function hydrateRecentlyViewed() {
  const root = document.querySelector('[data-ash-pdp-rv]');
  if (!root || root.dataset.ashPdpRvHydrated === '1') return;

  const sectionId = root.dataset.sectionId;
  const currentId = root.dataset.currentProductId;
  const max = parseInt(root.dataset.maxItems || '6', 10);
  if (!sectionId || !window.Theme?.routes?.search_url) return;

  const ids = RecentlyViewed.getProducts()
    .filter((id) => String(id) !== String(currentId))
    .slice(0, max);
  if (ids.length === 0) return;

  root.dataset.ashPdpRvHydrated = '1';

  const url = new URL(Theme.routes.search_url, location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('type', 'product');

  try {
    await sectionRenderer.renderSection(sectionId, { cache: false, url });
    const updated = document.querySelector(`[data-ash-pdp-rv][data-section-id="${sectionId}"]`);
    const hasCards = updated?.querySelector('.ash-xs__card');
    if (updated) updated.hidden = !hasCards;
  } catch (err) {
    console.warn('[ash-pdp-recently-viewed]', err);
    root.hidden = true;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateRecentlyViewed);
} else {
  hydrateRecentlyViewed();
}
